export default __webpack_public_path__ + "static/media/a1-4-3.c4ae0cea.jpg";